<template>
  <div class="noSlide">
    <!-- 单排可滑动列表 -->
    <div ref="scroll" class="item-container">
      <div v-for="(item, key) in list" :key="key" @click="clickOpen(item)" class="item">
        <img :src="item.icon">
        <div>{{item.title}}</div>
      </div>
    </div>
    <div class="progress-container"><span class="progress"><span :style="{left: 0.39*scrollPer+'rem'}"></span></span></div>
  </div>
</template>

<script>
import { cblockItem } from '@/api/app'

export default {
  name: 'NotslideRow',
  props: ['list'],
  data () {
    return {
      scrollPer: 0,
      startLeft: 0,
      startTopAbsolute: 0
    }
  },
  mounted() {
    this.addListener()
  },
  methods: {
    clickOpen: function(item){
      cblockItem(item, this)
    },
    handleTouchStart(e) {
      const touch = e.touches[0];
      this.startLeft = touch.pageX;
      this.startTopAbsolute = touch.clientY;
    },
    handleTouchMove(e) {
      const touch = e.touches[0];
      const currentLeft = touch.pageX;
      const currentTopAbsolute = touch.clientY;
      var offsetLeft = currentLeft - this.startLeft;
      var offsetTop = currentTopAbsolute - this.startTopAbsolute;
      var distanceX = Math.abs(offsetLeft);
      var distanceY = Math.abs(offsetTop);
      if (distanceX < 5 || (distanceX >= 5 && distanceY >= 1.73 * distanceX)) {
        // 纵向滑动 判定
        return;
      }
      e.stopPropagation()
    },
    handleScroll() {
      const elem = this.$refs.scroll
      this.scrollPer = elem.scrollWidth == 0?0:elem.scrollLeft/(elem.scrollWidth-elem.clientWidth)
    },
    addListener() {
      this.$refs.scroll.addEventListener('touchstart', this.handleTouchStart);
      this.$refs.scroll.addEventListener('touchmove', this.handleTouchMove);
      this.$refs.scroll.addEventListener('scroll', this.handleScroll)
    },
    removeListener() {
      const elem = this.$refs.scroll;
      elem.removeEventListener('touchstart', this.handleTouchStart);
      elem.removeEventListener('touchmove', this.handleTouchMove);
      elem.removeEventListener('scroll', this.handleScroll);
    }
  },
  beforeDestroy() {
    this.removeListener()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.noSlide {
  /* border-radius: 6px; */
  padding: 13px 6px 0 6px;
  overflow: hidden;
  color: #333333;
}
.noSlide>.item-container{
  display: flex;
  text-align: center;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  overflow-y: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
}
.noSlide>.item-container::-webkit-scrollbar{
  display: none;
}
.noSlide .item {
    color: #333333;
    font-size: 13px;
    min-width: 72px;
    /* max-width: 5rem; */
    margin-bottom: 6px;
    flex: 1;
}
.noSlide .item img{
    width: 45px;
    height: 45px;
    border-radius: 22px;
    margin: 0 auto 6px auto;
}
.progress-container{
  text-align: center;
  display: block !important;
}
.progress-container .progress{
  display: inline-block;
  width: 26px;
  background-color: #E6F5FF;
  height: 3px;
  border-radius: 2px;
  position: relative;
}
.progress-container .progress>span{
  content: '';
  position: absolute;
  display: inline-block;
  
  width: 12px;
  height: 3px;
  border-radius: 2px;
  background-color: #47B3FF;
  left: 0;
  z-index: 0;
}
</style>
